export default __webpack_public_path__ + "static/media/lc-2.24a72a10.JPG";